import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-lead-creation',
    templateUrl: './lead-creation.component.html',
    styleUrls: ['./lead-creation.component.scss'],
    standalone: false
})
export class LeadCreationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
